(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[651],{

/***/ 9318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutors/[slug]/send-message",
      function () {
        return __webpack_require__(21960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TutorProfileSummaryPanel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-regular-svg-icons/index.es.js
var free_regular_svg_icons_index_es = __webpack_require__(56024);
;// CONCATENATED MODULE: ./components/tutorProfile/Availability.js



function TutorProfileAvailability(param) {
    let { tutorProfile  } = param;
    const availabilityAttributes = {
        availableWeekdayDays: "Weekday daytime",
        availableWeekdayEvenings: "Weekday evenings",
        availableWeekends: "Weekends"
    };
    const availabilityKeys = Object.keys(availabilityAttributes);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: availabilityKeys.map((availabilityKey)=>{
            const hasAvailability = tutorProfile[availabilityKey];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: hasAvailability ? free_regular_svg_icons_index_es/* faCheckCircle */.f8k : free_regular_svg_icons_index_es/* faDotCircle */._1v,
                        fixedWidth: true,
                        className: "me-1 ".concat(hasAvailability ? "text-success" : "text-muted")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: !hasAvailability ? "text-secondary text-decoration-line-through" : "",
                        children: availabilityAttributes[availabilityKey]
                    })
                ]
            }, availabilityKey);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(22859);
;// CONCATENATED MODULE: ./components/tutorProfile/SummaryPanel.js






function TutorProfileSummaryPanel(param) {
    let { tutorProfile , showName  } = param;
    const referenceAverageAttributes = [
        {
            attribute: "averageReliabilityRating",
            label: "Reliability"
        },
        {
            attribute: "averageCommitmentRating",
            label: "Commitment"
        },
        {
            attribute: "averagePunctualityRating",
            label: "Punctuality"
        },
        {
            attribute: "averageHonestyRating",
            label: "Honesty"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-4 text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: tutorProfile.profilePicture.url,
                        alt: "".concat(tutorProfile.firstNameAndLastInitial, " photo"),
                        width: 200,
                        height: 200,
                        className: "rounded mb-2",
                        style: {
                            maxWidth: "100%",
                            height: "auto"
                        }
                    }),
                    showName && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "mb-3",
                        children: tutorProfile.fullName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        className: "d-block",
                        children: tutorProfile.tagLine
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: "Availability"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TutorProfileAvailability, {
                tutorProfile: tutorProfile
            }),
            tutorProfile.lessonsAtHome && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons_index_es/* faHome */.J9Y,
                        fixedWidth: true,
                        className: "text-success me-1"
                    }),
                    "Gives Lessons at Home"
                ]
            }),
            tutorProfile.lessonsTravel && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons_index_es/* faRoute */.FpQ,
                        fixedWidth: true,
                        className: "text-success me-1"
                    }),
                    "Will Travel to You"
                ]
            }),
            tutorProfile.lessonsOnline && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons_index_es/* faLaptop */.aNY,
                        fixedWidth: true,
                        className: "text-success me-1"
                    }),
                    "Gives Lessons Online"
                ]
            }),
            tutorProfile.hasDbsCertificate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons_index_es/* faCertificate */.Ua$,
                                fixedWidth: true,
                                className: "text-success me-1"
                            }),
                            "Has DBS Certificate"
                        ]
                    })
                ]
            }),
            tutorProfile.hasCompletedReferences && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        children: [
                            "References",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons_index_es/* faInfoCircle */.sqG,
                                        fixedWidth: true,
                                        size: "sm"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        title: "Average ratings across all references for this tutor"
                                    })
                                ]
                            })
                        ]
                    }),
                    referenceAverageAttributes.map((average)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons_index_es/* faShieldAlt */.U7t,
                                    fixedWidth: true,
                                    className: "text-success me-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        average.label,
                                        ":"
                                    ]
                                }),
                                tutorProfile[average.attribute]
                            ]
                        }, average))
                ]
            })
        ]
    });
}


/***/ }),

/***/ 34550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(theme) {
    return {
        ...theme,
        colors: {
            ...theme.colors,
            primary: "#2c3e50",
            primary25: "#ecf0f1"
        }
    };
}


/***/ }),

/***/ 21960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ TutorsProfileReviews; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78182);
/* harmony import */ var _components_tutorProfile_SummaryPanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(561);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51436);
/* harmony import */ var _components_tutorRequest_RequestContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6006);











var __N_SSG = true;
function TutorsProfileReviews(param) {
    let { tutorProfile  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                    children: [
                        "Send Message | ",
                        tutorProfile.firstNameAndLastInitial,
                        " | Tutorspot"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: "pt-3 mb-5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                        className: "mb-3",
                        children: [
                            "Send a Message to ",
                            tutorProfile.firstNameAndLastInitial
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                xs: 12,
                                md: 8,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mb-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/tutors/".concat(tutorProfile.slug),
                                            passHref: true,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faArrowLeft */ .acZ,
                                                    className: "me-1"
                                                }),
                                                "Back to Profile"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tutorRequest_RequestContainer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                tutorProfile: tutorProfile
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                xs: 12,
                                md: 4,
                                className: "d-none d-md-block",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Body */ .Z.Body, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tutorProfile_SummaryPanel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            tutorProfile: tutorProfile
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97346);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);





function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var noop = function noop() {
  return null;
};

var GroupContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var Group = function Group(_ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      error = _ref.error,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "helpText", "error", "children"]);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      fieldError = _useField[1].error;

  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(GroupContext.Provider, {
    value: {
      name: props.name
    }
  }, react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Group */ .Z.Group, Object.assign({}, props), label && react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Label */ .Z.Label, null, label), children, react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Control.Feedback */ .Z.Control.Feedback, {
    type: "invalid"
  }, error != null ? error : fieldError), helpText && react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Text */ .Z.Text, {
    muted: true
  }, helpText)));
};

var Checkbox = function Checkbox(_ref) {
  var custom = _ref.custom,
      props = _objectWithoutPropertiesLoose(_ref, ["custom"]);

  var _useFormikContext = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useFormikContext */ .u6)(),
      values = _useFormikContext.values,
      errors = _useFormikContext.errors,
      touched = _useFormikContext.touched,
      setFieldValue = _useFormikContext.setFieldValue,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GroupContext),
      _useContext$name = _useContext.name,
      groupName = _useContext$name === void 0 ? "" : _useContext$name;

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      _useField$ = _useField[0],
      name = _useField$.name,
      onBlur = _useField$.onBlur;

  var isChecked = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return values[groupName].includes(name);
  }, [groupName, name, values]);
  var isInvalid = Boolean(errors[groupName]) && touched[groupName];
  var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e) {
    props.onChange(e);
    setFieldTouched(groupName, true);
    setFieldValue(groupName, isChecked ? values[groupName].filter(function (value) {
      return value !== name;
    }) : [].concat(values[groupName], [name]));
  }, [groupName, isChecked, name, props, setFieldTouched, setFieldValue, values]);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check */ .Z.Check, Object.assign({}, props, {
    id: name,
    type: "checkbox",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
      "is-invalid": isInvalid
    }),
    custom: custom
  }), react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check.Input */ .Z.Check.Input, Object.assign({}, props, {
    type: "checkbox",
    checked: isChecked,
    isInvalid: isInvalid,
    onChange: handleChange,
    onBlur: onBlur
  })), react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check.Label */ .Z.Check.Label, {
    title: props.title
  }, props.label));
};
Checkbox.defaultProps = {
  onChange: noop
};

function useChange(props) {
  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      onChange = _useField[0].onChange;

  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e) {
    return props.onChange(e), onChange(e);
  }, [onChange, props.onChange]);
}

var Input = function Input(_ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "helpText"]);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      _useField$ = _useField[0],
      name = _useField$.name,
      value = _useField$.value,
      onBlur = _useField$.onBlur,
      _useField$2 = _useField[1],
      error = _useField$2.error,
      touched = _useField$2.touched;

  var handleChange = useChange(props);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Group, {
    name: name,
    controlId: name,
    label: label,
    helpText: helpText,
    error: error
  }, react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Control */ .Z.Control, Object.assign({}, props, {
    name: name,
    value: value == null ? void 0 : value.toString(),
    isInvalid: Boolean(error) && touched,
    onChange: handleChange,
    onBlur: onBlur
  })));
};
Input.defaultProps = {
  onChange: noop
};

var Radio = function Radio(_ref) {
  var custom = _ref.custom,
      props = _objectWithoutPropertiesLoose(_ref, ["custom"]);

  var _useFormikContext = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useFormikContext */ .u6)(),
      values = _useFormikContext.values,
      errors = _useFormikContext.errors,
      touched = _useFormikContext.touched,
      setFieldValue = _useFormikContext.setFieldValue,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(GroupContext),
      _useContext$name = _useContext.name,
      groupName = _useContext$name === void 0 ? "" : _useContext$name;

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      _useField$ = _useField[0],
      name = _useField$.name,
      onBlur = _useField$.onBlur;

  var isInvalid = Boolean(errors[groupName]) && touched[groupName];
  var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (e) {
    props.onChange(e);
    setFieldTouched(groupName, true);
    setFieldValue(groupName, name);
  }, [groupName, name, props.onChange, setFieldTouched, setFieldValue]);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check */ .Z.Check, Object.assign({}, props, {
    id: name,
    name: groupName,
    type: "radio",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
      "is-invalid": isInvalid
    }),
    custom: custom
  }), react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check.Input */ .Z.Check.Input, Object.assign({}, props, {
    type: "radio",
    checked: values[groupName] === name,
    isInvalid: isInvalid,
    onChange: handleChange,
    onBlur: onBlur
  })), react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Check.Label */ .Z.Check.Label, {
    title: props.title
  }, props.label));
};
Radio.defaultProps = {
  onChange: noop
};

var Range = function Range(props) {
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Input, Object.assign({}, props, {
    type: "range"
  }));
};

var Select = function Select(_ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      placeholder = _ref.placeholder,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "helpText", "placeholder", "children"]);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      _useField$ = _useField[0],
      name = _useField$.name,
      value = _useField$.value,
      onBlur = _useField$.onBlur,
      _useField$2 = _useField[1],
      error = _useField$2.error,
      touched = _useField$2.touched;

  var handleChange = useChange(props);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Group, {
    name: name,
    controlId: name,
    label: label,
    helpText: helpText,
    error: error
  }, react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Control */ .Z.Control, Object.assign({}, props, {
    as: "select",
    name: name,
    value: value == null ? void 0 : value.toString(),
    isInvalid: Boolean(error) && touched,
    onChange: handleChange,
    onBlur: onBlur
  }), placeholder && react__WEBPACK_IMPORTED_MODULE_1__.createElement("option", {
    value: "",
    disabled: true
  }, placeholder), children));
};
Select.defaultProps = {
  onChange: noop
};

var Textarea = function Textarea(_ref) {
  var label = _ref.label,
      helpText = _ref.helpText,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "helpText"]);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_0__/* .useField */ .U$)(props),
      _useField$ = _useField[0],
      name = _useField$.name,
      value = _useField$.value,
      onBlur = _useField$.onBlur,
      _useField$2 = _useField[1],
      error = _useField$2.error,
      touched = _useField$2.touched;

  var handleChange = useChange(props);
  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(Group, {
    name: name,
    controlId: name,
    label: label,
    helpText: helpText,
    error: error
  }, react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Control */ .Z.Control, Object.assign({}, props, {
    as: "textarea",
    name: name,
    value: value == null ? void 0 : value.toString(),
    isInvalid: Boolean(error) && touched,
    onChange: handleChange,
    onBlur: onBlur
  })));
};
Textarea.defaultProps = {
  onChange: noop
};

var Form = function Form(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "children"]);

  return react__WEBPACK_IMPORTED_MODULE_1__.createElement(formik__WEBPACK_IMPORTED_MODULE_0__/* .Formik */ .J9, Object.assign({}, props), function (_ref2) {
    var handleSubmit = _ref2.handleSubmit;
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      className: className,
      onSubmit: handleSubmit
    }, children);
  });
};
Form.Group = Group;
Form.Input = Input;
Form.Textarea = Textarea;
Form.Select = Select;
Form.Checkbox = Checkbox;
Form.Radio = Radio;
Form.Range = Range;


//# sourceMappingURL=react-bootstrap-formik.esm.js.map


/***/ }),

/***/ 88375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var uncontrollable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47150);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78146);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76792);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41068);
/* harmony import */ var _CloseButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41485);
/* harmony import */ var _divWithClassName__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39602);
/* harmony import */ var _createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66611);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);












const DivStyledAsH4 = (0,_divWithClassName__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('h4');
DivStyledAsH4.displayName = 'DivStyledAsH4';
const AlertHeading = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-heading', {
  Component: DivStyledAsH4
});
const AlertLink = (0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('alert-link', {
  Component: _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z
});
const defaultProps = {
  variant: 'primary',
  show: true,
  transition: _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
  closeLabel: 'Close alert'
};
const Alert = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((uncontrolledProps, ref) => {
  const {
    bsPrefix,
    show,
    closeLabel,
    closeVariant,
    className,
    children,
    variant,
    onClose,
    dismissible,
    transition,
    ...props
  } = (0,uncontrollable__WEBPACK_IMPORTED_MODULE_2__/* .useUncontrolled */ .Ch)(uncontrolledProps, {
    show: 'onClose'
  });
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'alert');
  const handleClose = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e => {
    if (onClose) {
      onClose(false, e);
    }
  });
  const Transition = transition === true ? _Fade__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z : transition;

  const alert = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    role: "alert",
    ...(!Transition ? props : undefined),
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
    children: [dismissible && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CloseButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      onClick: handleClose,
      "aria-label": closeLabel,
      variant: closeVariant
    }), children]
  });

  if (!Transition) return show ? alert : null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(Transition, {
    unmountOnExit: true,
    ...props,
    ref: undefined,
    in: show,
    children: alert
  });
});
Alert.displayName = 'Alert';
Alert.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Alert, {
  Link: AlertLink,
  Heading: AlertHeading
}));

/***/ }),

/***/ 22859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/helpers.js

class BsPrefixComponent extends react.Component {} // Need to use this instead of typeof Component to get proper type checking.

function getOverlayDirection(placement, isRTL) {
  let bsDirection = placement;

  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }

  return bsDirection;
}
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js






const defaultProps = {
  placement: 'right'
};
const Tooltip = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  placement,
  className,
  style,
  children,
  arrowProps,
  popper: _,
  show: _2,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'tooltip');
  const isRTL = (0,ThemeProvider/* useIsRTL */.SC)();
  const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
  const bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    style: style,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classnames_default()(className, bsPrefix, `bs-tooltip-${bsDirection}`),
    ...props,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "tooltip-arrow",
      ...arrowProps
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: `${bsPrefix}-inner`,
      children: children
    })]
  });
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
/* harmony default export */ var esm_Tooltip = (Tooltip);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [766,734,687,6,774,888,179], function() { return __webpack_exec__(9318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);